import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../services/date-range-time-filters.service";

export class BringozTableColumnsSettingsComponent implements IController {
  columns: any;
  isOpen: boolean;
  columnsTranslationPrefix: string;
  onToggleIsOpen: Function;
  onColumnsChange: Function;

  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozTableColumnsSettings', {
    bindings: {
      columns: '<',
      title: '@?',
      isOpen: '<?',
      columnsTranslationPrefix: '@?',
      onToggleIsOpen: '&',
      onColumnsChange: '&'
    },
    template: require('./bringoz-table-columns-settings.html').default,
    controller: BringozTableColumnsSettingsComponent
  });
